import React from 'react';
import { ImageSearchContent } from '../components/ImageSearchContent';
import { Images } from 'lucide-react';

export default function ImageSearch() {
  return (
    <div className="co-page co-scope co-settings" data-testid="image-search-page">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-2 mb-1">
          <Images className="h-5 w-5 text-[#37c9ee]" />
          <h1 className="text-2xl font-bold">Image Search</h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">Search images and screenshots attached to your tickets by file name, or by ticket subject or number. This does not search the web and does not match images by appearance.</p>
        <ImageSearchContent />
      </div>
    </div>
  );
}
